import {  useEffect } from 'react';
import './footer.scss'
import { useTranslation } from 'react-i18next';
import i18n from '../../../utils/i18n';
import { Link, useLocation } from 'react-router';
import { SocialNetworks } from '../../social-networks/social-networks';

export default function Footer(){
    const location = useLocation();
    const lang = location.pathname.split('/')[1];
    const { t } = useTranslation();
    
    useEffect(()=>{
        i18n.changeLanguage(lang);
    },[lang]);

    function getYear(){
        const date = new Date();
        return date.getFullYear();
    }

    return(
        <footer>
            <SocialNetworks/>
            <div className='flex align-center justify-center'>
                <a>www.jnicolas.art</a> &nbsp;- {t("footer.all_right_reserved")} &copy; - {getYear()}
            </div>
            <div className='flex align-center justify-end flex-gap'>
                <Link to={`${lang}/legal-notice`}> {t("footer.legal_notice")}</Link>
                <Link to={`${lang}/privacy-policy`}> {t("footer.privacy_policy")}</Link>
            </div>
        </footer>
    )
}